import _ from 'underscore';

const defaultAfterFindAll = (options, data) => data;
/**
 * Previously, we accessed the error through the grid instance,
 * but now we prefetch the grid odata call,
 * when we execute afterFindAll there is no grid instance constructed yet,
 * so we access the error through the dataSource instance
 */
export class QueryErrorFactory {
  static make(dataSourceConfig) {
    const errors = {
      tooMuchDataError: false,
    };
    const originalAfterFindAll = dataSourceConfig.options.afterFindAll || defaultAfterFindAll;
    // eslint-disable-next-line no-param-reassign
    dataSourceConfig.options.afterFindAll = (options, data = {}) => {
      _.mapObject(errors, (val, key) => {
        errors[key] = false;
      });
      if (_.any(data.errors, err => err.Code === 'TooMuchDataToDownload')) {
        errors.tooMuchDataError = true;
      }
      return originalAfterFindAll(options, data);
    };
    return errors;
  }
}
